import { event, eventListingSection } from '@stereoagency/sanity-schema';
import { TaxonomyType } from '@stereoagency/constants';
import UIEventListingSection from './EventListingSection.client';
import { fetchTaxonomyCounts } from '@/fetchers';

type Props = typeof eventListingSection.schema.eventListingSection;

export default async function EventListingSection({
  enableTaxonomyFilter
}: Props) {
  const totalCounts = await fetchTaxonomyCounts(
    [TaxonomyType.EVENT_CATEGORY],
    [event.schema.document.name]
  );

  return (
    <UIEventListingSection
      enableTaxonomyFilter={enableTaxonomyFilter}
      taxonomyCounts={Object.fromEntries(totalCounts.entries())}
    />
  );
}
